// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WindowsOutlinedSvg from "@fishx/icons-svg/es/asn/WindowsOutlined";
import FishxIcon from '../components/FishxIcon';

var WindowsOutlined = function WindowsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WindowsOutlinedSvg
  }));
};

WindowsOutlined.displayName = 'WindowsOutlined';
export default React.forwardRef(WindowsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WindowsOutlined.js
// module id = 4407
// module chunks = 0